var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReorderCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 44,
    viewBox: "0 0 61 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "xph2zdzela",
    width: 12,
    height: 20,
    x: 0,
    y: 24,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "m1s4c24sxb",
    width: 12,
    height: 20,
    x: 33,
    y: 24,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "myyzrrdqmc",
    width: 12,
    height: 20,
    x: 16,
    y: 24,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "gejzhn1x7d",
    width: 12,
    height: 20,
    x: 49,
    y: 24,
    rx: 1
  }), /*#__PURE__*/React.createElement("mask", {
    id: "9t4aa0s28e",
    width: 12,
    height: 20,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xph2zdzela"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "u56d7pz4af",
    width: 12,
    height: 20,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m1s4c24sxb"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "2igqc4cpwg",
    width: 12,
    height: 20,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#myyzrrdqmc"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "hcc9yq13gh",
    width: 12,
    height: 20,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gejzhn1x7d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-94.000000, -1185.000000) translate(60.000000, 1149.000000) translate(34.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#2CABE0",
    rx: 1
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#2CABE0",
    strokeDasharray: 3,
    strokeWidth: 1.4,
    mask: "url(#9t4aa0s28e)",
    xlinkHref: "#xph2zdzela"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 33.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#2CABE0",
    rx: 1
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#2CABE0",
    strokeDasharray: 3,
    strokeWidth: 1.4,
    mask: "url(#u56d7pz4af)",
    xlinkHref: "#m1s4c24sxb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 16.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#2CABE0",
    rx: 1
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#2CABE0",
    strokeDasharray: 3,
    strokeWidth: 1.4,
    mask: "url(#2igqc4cpwg)",
    xlinkHref: "#myyzrrdqmc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 49.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#2CABE0",
    rx: 1
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#2CABE0",
    strokeDasharray: 3,
    strokeWidth: 1.4,
    mask: "url(#hcc9yq13gh)",
    xlinkHref: "#gejzhn1x7d"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#2CABE0",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4,
    y: 13
  }, "3")), /*#__PURE__*/React.createElement("text", {
    fill: "#2CABE0",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 13
  }, "1")), /*#__PURE__*/React.createElement("text", {
    fill: "#2CABE0",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 37,
    y: 13
  }, "2")), /*#__PURE__*/React.createElement("text", {
    fill: "#2CABE0",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 53,
    y: 13
  }, "4"))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorderCards);
export default __webpack_public_path__ + "static/media/reorder-cards.5ec1df235041dda3bde602bf68052a90.svg";
export { ForwardRef as ReactComponent };